import { ReactNode } from "react";

import { GameVisuals } from "../../../gql/graphql";

import styles from "./Background.module.scss";

export const Background = ({ children, gameVisuals }: { children: ReactNode; gameVisuals: GameVisuals }) => {
  if (gameVisuals.backgroundImage) {
    const backgroundStyles = { backgroundImage: `url(${gameVisuals.backgroundImage.url})` };

    return (
      <div className={styles.background} style={backgroundStyles}>
        {children}
      </div>
    );
  }

  return (
    <div className={styles.background}>
      <div className={styles.purpleShadow} style={{ backgroundColor: gameVisuals.backgroundNegativeColor }} />
      <div className={styles.orangeShadow} style={{ backgroundColor: gameVisuals.backgroundPositiveColor }} />
      {children}
    </div>
  );
};
